// extracted by css-extract-rspack-plugin
export default {"card":"cLrj8O6mRPgaw6Kv__card___","textContainer":"c9mmLswIwIBtrIeQ__textContainer___","objectType":"auc46okqrU8ZtolA__objectType___","active":"sdHoMfIew9JsH9KI__active___"};